<template>
  <main class="a-service-main">
    <div class="a-service-container">
      <!-- S : 아코디언 텍스트 박스 -->
      <composed-pack-section :expected-total-price="expectedTotalPrice" :products="selectedProducts" />
      <!-- E : info text box -->

      <composition-options-section v-model="options" />

      <template v-for="productGroup in productGroups">
        <product-section
          :key="productGroup.name"
          :title="productGroup.name"
          :product-group="productGroup.items"
          :show-total="true"
          @dose-change="onDoseChanged"
        />
      </template>

      <main-button-group
        title-left="이전"
        title-right="다음"
        :disabled-right="!canProceedNext"
        @click-left="$router.back()"
        @click-right="proceedNext"
      />
    </div>
    <!-- E : 컨텐츠 영역 -->
    <!-- S : 플로팅 버튼 -->
    <floating-button-group
      title="다음"
      :disabled="!canProceedNext"
      :expected-total-price="expectedTotalPrice"
      :enable-total-price="true"
      @click="proceedNext"
    />
    <!-- E : 플로팅 버튼-->
    <modal-alert ref="refAlert" />
  </main>
</template>
<script>
import { DOUBLE_X_SKU } from '@/utils/constants';
import productHelpers from '@/utils/helpers/product';
import compositionHelpers from '@/utils/helpers/composition';
import { mapGetters } from 'vuex';
import FloatingButtonGroup from '@/components/FloatingButtonGroup.vue';
import MainButtonGroup from '@/components/MainButtonGroup.vue';
import { log } from '@/utils/common';
import ModalAlert from '@/components/global/ModalAlert';
import ComposedPackSection from './ComposedPackSection.vue';
import CompositionOptionsSection from './CompositionOptionsSection.vue';
import ProductSection from '../../common/ProductSection.vue';
import mixin from '../../common/mixin';

export default {
  name: 'CompositionStep2',
  components: {
    FloatingButtonGroup,
    MainButtonGroup,
    ComposedPackSection,
    CompositionOptionsSection,
    ProductSection,
    ModalAlert,
  },
  mixins: [mixin],
  data() {
    return {
      isRollback: false,
      options: {
        days: false,
        pockets: false,
      },
      productGroups: [],
      selectedProducts: [],
      expectedTotalPrice: 0,
    };
  },
  computed: {
    ...mapGetters({
      context: 'context/context',
      products: 'product/products',
    }),
    canProceedNext() {
      return this.options.days && this.options.pockets;
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        if (this.isRollback) {
          this.isRollback = false;
          return;
        }

        if (!this.options.days || !this.options.pockets) {
          this.productGroups = [];
          return;
        }
        this.productGroups = productHelpers
          .genProductGroupsByPocketCount(
            this.products,
            this.options.pockets,
            this.selectedProducts,
          );
      },
    },
  },
  created() {
    this.checkContext();

    if (this.context.bundle.step2.finalSkus.length > 0) {
      this.checkRequireRollback();
    }
  },
  methods: {
    checkContext() {
      const ctx = this.context.bundle;
      const pockets = ctx.step2.finalSkus.length > 0
        ? ctx.step2.finalSkus[0].pockets : -1;
      this.productGroups = productHelpers
        .genProductGroupsByPocketCount(
          this.products,
          pockets,
          ctx.step1.selectedSkus,
          ctx.step2.finalSkus,
        );
      this.selectedProducts = productHelpers
        .getProductsFromSkus(this.products, this.context.bundle.step1.selectedSkus);
      this.expectedTotalPrice = this.context.bundle.step1.selectedSkus.reduce((acc, cur) => acc + (cur.price * cur.count) * 30, 0);
    },
    checkRequireRollback() {
      if (this.context.bundle.step2) {
        // 이전 상태로 롤백
        log('CompositionStep2::created', 'checkRequireRollback', this.context.bundle);
        this.rollbackState(this.context.bundle.step2.finalSkus);
      } else {
        this.$router.push('/');
      }
    },
    rollbackState(skus) {
      const finalSkus = JSON.parse(JSON.stringify(skus));

      this.options.days = finalSkus[0].days.toString();
      this.options.pockets = finalSkus[0].pockets.toString();

      finalSkus.forEach((n) => {
        console.log(n);
        switch (this.options.pockets) {
          case '1': break;
          case '2': this.preselectWhenPocket2(n); break;
          case '3': console.warn('pocket 3 case is not defined.'); break;
          default: console.warn('undefined pocket count.');
        }
      });

      this.isRollback = true;
    },
    preselectWhenPocket2(product) {
      const doses = product.seq.split(',');
      // eslint-disable-next-line prefer-destructuring
      let group1 = this.productGroups[0].items
        .find((n) => n.item_sku === product.item_sku)
      if (group1) {
        group1.selectedCount = product.item_sku === DOUBLE_X_SKU
          ? parseInt(doses[0], 10) * 3 : parseInt(doses[0], 10);
      }
      // eslint-disable-next-line prefer-destructuring
      let group2 = this.productGroups[1].items
        .find((n) => n.item_sku === product.item_sku)
      if (group2) {
        group2.selectedCount = product.item_sku === DOUBLE_X_SKU
          ? parseInt(doses[2], 10) * 3 : parseInt(doses[2], 10);
      }

    },

    onDoseChanged(item) {
      let productGroup;
      if (this.options.pockets === '2' && item.seq === 3) {
        // eslint-disable-next-line prefer-destructuring
        productGroup = this.productGroups[1];
      } else {
        productGroup = this.productGroups[item.seq - 1];
      }

      let group = productGroup
        .items
        .find((n) => n.item_sku === item.item_sku)
      if (group) {
        group.selectedCount = item.selectedCount;
      }

      switch (this.options.pockets) {
        case '2':
          productHelpers.resplitProductGroupsBy2(item, this.productGroups);
          break;
        case '3':
          productHelpers.resplitProductGroupsBy3(item, this.productGroups);
          break;
        default: console.warn('what\'s going on?');
      }
    },

    validateFinalCounts() {
      return this.productGroups[0].items.reduce((acc, n, idx) => {
        const sum = this.productGroups.reduce((acc2, n2) => {
          // eslint-disable-next-line no-param-reassign
          acc2.count = n2.items[idx].count; // 증가 시키지 않는다.
          // eslint-disable-next-line no-param-reassign
          acc2.selectedCount += n2.items[idx].selectedCount;
          return acc2;
        }, {
          count: 0,
          selectedCount: 0,
        });
        if (sum.count !== sum.selectedCount) {
          if (sum.count > sum.selectedCount) {
            acc.push({
              msg: `${n.item_name}(이)가 ${sum.count - sum.selectedCount}개 부족합니다.`,
              item_sku: n.item_sku,
            });
          } else {
            acc.push({
              msg: `${n.item_name}(이)가 ${sum.selectedCount - sum.count}개 초과 되었습니다.`,
              item_sku: n.item_sku,
            });
          }
        }
        return acc;
      }, []);
    },

    validateMinimunDoses() {
      return this.productGroups
        .reduce((acc, n) => {
          const sum = n.items.reduce((acc2, n2) => acc2 + n2.selectedCount, 0);
          log('CompositionStep2::validateMinimunDoses', n.name, sum, sum > 0);

          return acc && (sum > 0);
        },
        true);
    },
    validateMaximumDoses(finalSkus) {
      let countPocket1 = 0;
      let countPocket2 = 0;
      let countPocket3 = 0;
      finalSkus.forEach((n) => {
        let seqs = n.seq.split(',').map((n1) => parseInt(n1, 10));
        if (n.item_sku === DOUBLE_X_SKU) {
          seqs = seqs.map((x) => x * 3);
        }

        countPocket1 += seqs[0];
        countPocket2 += seqs[1];
        countPocket3 += seqs[2];
      });

      if (countPocket1 > 12 || countPocket2 > 12 || countPocket3 > 12) {
        log('CompositionStep2::validateMaximumDoses',
          false,
          countPocket1,
          countPocket2,
          countPocket3);
        return false;
      }
      log('CompositionStep2::validateMaximumDoses',
        true,
        countPocket1,
        countPocket2,
        countPocket3);
      return true;
    },
    setContextWithSelectedProducts(productSkus) {
      const ctx = JSON.parse(JSON.stringify(this.context));
      compositionHelpers.updateStep2(ctx, productSkus);
      compositionHelpers.updateContext(this.$store, ctx);
    },
    async proceedNext() {
      log('CompositionStep2::proceedNext');
      // 이전 단계에서 선택한 개수 비교
      const validated = this.validateFinalCounts();
      if (validated.length > 0) {
        const msg = validated.reduce((acc, n) => `${acc}${n.msg}\n`, '');
        await this.$refs.refAlert.openWithMessage(msg);
        return;
      }

      if (!this.validateMinimunDoses()) {
        await this.$refs.refAlert.openWithMessage('한 포에 최소 1개의 구성품이 필요합니다.');
        return;
      }

      // 최종 선택된 상품 구성 생성

      const finalSkus = productHelpers
        .genFinalSkusFromProductPocketGroups(
          this.productGroups,
          parseInt(this.options.days, 10),
          parseInt(this.options.pockets, 10),
        );

      if (!this.validateMaximumDoses(finalSkus)) {
        log('CompositionStep2::proceedNext', 'validateMaximumDoses', '한 포당 12알이 최대입니다.');
        await this.$refs.refAlert.openWithMessage('한 포당 12알이 최대입니다. 한 포당 12알이 넘지 않도록 하루 섭취 포의 수, 제품의 수 혹은 오전/오후 섭취 알 수를 조정해주세요.');
        return;
      }

      log('CompositionStep2::proceedNext', 'final', finalSkus);
      this.setContextWithSelectedProducts(finalSkus);

      this.$router.push('/composition/step3');
    },

  },
};
</script>
